import React, { useEffect, useState } from 'react';

import { enqueueSnackbar } from 'notistack';

import { StripeSetCardModal } from '../../../../../../../shared/components/stripe';
import { stripeService } from '../../../../../../services/stripeService';
import { EntityPaymentMethodDetails } from '../../../../../../../shared/interfaces/entityPaymentMethodDetails';

type UpdateCardModalProps = {
  entityId: number;
  onSuccessSubmit: (paymentMethodDetails: EntityPaymentMethodDetails) => void;
  onClose: () => void;
};

const UpdateCardModal = ({
  entityId,
  onSuccessSubmit,
  onClose,
}: UpdateCardModalProps) => {
  const [publishableKey, setPublishableKey] = useState<string>();

  const getStripeConnectedInfo = async () => {
    const { key } = await stripeService.getPublishApiKey();

    setPublishableKey(key);
  };

  useEffect(() => {
    getStripeConnectedInfo();
  }, []);

  const handleUpdateCard = async (paymentMethodId: string) => {
    onClose();

    const paymentMethodDetails = await stripeService.updateEntityCard(
      entityId,
      paymentMethodId,
    );

    enqueueSnackbar('The card has been updated', {
      variant: 'success',
      autoHideDuration: 5000,
    });

    onSuccessSubmit(paymentMethodDetails);
  };

  return (
    <StripeSetCardModal
      open={!!publishableKey}
      publishableKey={publishableKey}
      title="Update Card"
      onClose={onClose}
      onSubmit={handleUpdateCard}
    />
  );
};

export { UpdateCardModal };
